import { PickInfo } from '@deck.gl/core/lib/deck';
import { IconLayer, PointCloudLayer, TextLayer } from 'deck.gl';
import imageMarker from '../../../assets/icon/locate2.png';
import { MarkerItem } from '../../../typings/home';
import { ILabelLayer } from '../../../typings/map';

export type PointMarker = GeoJSON.Feature<GeoJSON.Point, MarkerItem>;
export const FWELAYER = 'fwe-point-layer';
export const INSITU_LAYER = 'insitu-point-layer';
export const POINT_LAYER = 'icon-layer';

export function FWEPointLayer<IFWPoint>(data: IFWPoint[]) {
  const layer = new PointCloudLayer({
    id: FWELAYER,
    data,
    pickable: true,
    getPosition: (d: any) => d.position,
    getColor: [255, 255, 0, 255],
    pointSize: 8,   
  })
  return layer
}

export function InSituPointLayer<InSituPoint>(data: InSituPoint[]) {
  const layer = new PointCloudLayer({
    id: INSITU_LAYER,
    data,
    pickable: true,
    getPosition: (d: any) => d.position,
    getColor: [255, 100, 101],
    pointSize: 8,   
  })
  return layer
}

export function MarkerLayer(
  data: MarkerItem[],
  onDrag?: (info: PickInfo<MarkerItem>, e: MouseEvent) => void,
  onDragStart?: (info: PickInfo<MarkerItem>, e: MouseEvent) => void,
  onDragEnd?: (info: PickInfo<MarkerItem>, e: MouseEvent) => void,
) {
  const ICON_MAPPING = {
    marker: { x: 0, y: 0, width: 128, height: 128, anchorY: 125, mask: true },
  };

  const layer = new IconLayer<MarkerItem>({
    id: 'icon-layer',
    data,
    pickable: true,
    // iconAtlas and iconMapping are required
    // getIcon: return a string
    iconAtlas: imageMarker,
    iconMapping: ICON_MAPPING,
    getIcon: (d) => 'marker',  
    getPosition: (d) => {
      return d.coordinates as [number, number];
    },
    getSize: (d) => 40,
    getColor: (d) => {
      if (d.active) {
        return [0, 164, 236];
      }
      return [142, 7, 77];
    },
    onDragStart: (info: PickInfo<MarkerItem>, e: any) => {
      return onDragStart && onDragStart(info, e);
    },
    onDrag: (info: PickInfo<MarkerItem>, e: any) => {
      return onDrag && onDrag(info, e);
    },
    onDragEnd: (info: PickInfo<MarkerItem>, e: any) => {
      return onDragEnd && onDragEnd(info, e);
    }, 
  });

  return layer;
}

export function LabelLayer(data: ILabelLayer[]) {
  const layer = new TextLayer({
    id: 'label-layer',
    data,
    pickable: false,
    getPosition: (d: any) => d.coordinates,
    getText: (d: any) => d.name,
    getColor: (d: any) => {
      if (d.active) {
        return [0, 164, 236];
      }
      return d.color;
    },
    getSize: (d: any) => (d.textSize ? d.textSize : 18), //24,
    getAngle: 0,
    getTextAnchor: (d: any) => (d.textAnchor ? d.textAnchor : 'start'), //'start' | 'middle' | 'end',
    getAlignmentBaseline: (d: any) =>
      d.alignmentBaseline ? d.alignmentBaseline : 'top', //'top' | 'center' | 'bottom',
    getPixelOffset: (d: any) => (d.pixelOffset ? d.pixelOffset : [0, 0]),
  });
  return layer;
}
